import React from "react";
import { Alert } from "@dev/ee-components";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { PaidListContactsStatus } from "../ChangeStatusProps";

const AlertWrapper = styled.div`
   margin-bottom: 16px;
`;

export const AlertComponent = ({ isOnPaidList, isContactFromPaidList }: PaidListContactsStatus): JSX.Element => {
    const { t } = useTranslation();

    if (!isOnPaidList && !isContactFromPaidList) {
        return null;
    }

    return (
        <AlertWrapper>
            <Alert 
                severity="info" 
                body={t(isOnPaidList ? 'changestatuslist_info' : 'changestatuslist_info2')} 
            />
        </AlertWrapper>
    );
};
